export const imageData = [
  {
    id: 2000000,
    title: "PROJECT DEBUT III",
    description:
      "An award-winning audiophile turntable is produced in Europe by the company Project Debut models the sellers and very successful of the project company received an upgrade in every respect in the evo model comes with a high-quality head ounted on a high-precision straight carbon arm an ultra-quiet motor and insulated from the turntable body",
    imgLink:
      "https://www.beatnik.co.il/wp-content/uploads/2021/06/project-debute-evo-black.jpg",
    price: "530",
  },
  {
    id: 2,
    title: "AUDIO TECHNICA USB",
    long_title: "AUDIO TECHNICA AT LP60X USB",
    description:
      "A semi-automatic turntable with strap drive is the simple and cost-effective solution to shake the dust from your vinyl collection with it USB connection to transfer music to your computer and a built-in pre-amplifier that allows connection to any type of amplification you have at home.",
    imgLink:
      "https://www.beatnik.co.il/wp-content/uploads/2018/03/AUDIO-TECHNICA-LP60-TURNTABLE1-e1590471001770.jpg",
    price: "240",
  },
  {
    id: 3,
    title: "PROJECT PRIMARY E",
    long_title: "PROJECT PRIMARY E PHONO",
    description:
      " A high-quality and designed turntable manufactured in Europe by the company Project comes tuned with a high-quality head 'ortofon om' Mounted on a high-precision straight aluminum arm tuned and ready to work",
    imgLink:
      "https://www.beatnik.co.il/wp-content/uploads/2021/06/primary-e.jpg",
    price: "420",
  },
  {
    id: 4,
    title: "SAFA ACE HP-H005",
    long_title: "SAFA ACE HP-H005 BLUETOOTH",
    description:
      "A high-quality strap-on turntable that includes a built-in pre-amplifier and a Bluetooth transmitter The turntable body is designed in arm wood Heavy aluminum plate head audio techica can be connected to any external amplification",
    imgLink:
      "https://www.beatnik.co.il/wp-content/uploads/2021/01/safa-004.jpg",
    price: "300",
  },
  {
    id: 5,
    title: "SAFA KT 3001",
    description:
      "Integrated audio system with a retro design that includes an amplifier turntable and powerful built-in speakers and an overall USB connection",
    imgLink: "https://www.beatnik.co.il/wp-content/uploads/2017/06/SAFA.jpg",
    price: "200",
  },
  {
    id: 6,
    title: "PROJECT T1 PHONO",
    long_title: "PROJECT T1 PHONO BT",
    description:
      "A high-quality, designed turntable is manufactured in Europe by the project company. The turntable does not include plastic parts but a wooden body and a glass plate. Comes tuned with a high-quality head 'Ortofon OM5E'",
    imgLink:
      "https://www.beatnik.co.il/wp-content/uploads/2021/06/T1PhonoSB.jpg",
    price: "560",
  },
];
